export const UserType = {
    CRIS: "본원",
    GENERAL: "일반",
    undefined: "",
}

export const UserTypeOptions = [
	{
		value: 'CRIS',
		label: UserType['CRIS'],
		checked: true,
	},
	{
		value: 'GENERAL',
		label: UserType['GENERAL'],
		checked: false,
	},
];

export const EducationStatus = {
	ABSTAIN: { kr: '불참', en: 'ABSTAIN', class: 'fc-vivid-red' },
	COMPLETE: { kr: '수료', en: 'COMPLETE', class: 'fc-blue' },
	REJECT: { kr: '반려', en: 'REJECT', class: 'fc-vivid-red' },
	EDU_END: { kr: '교육 종료', en: 'EDU_END', class: '' },
	EDU_BEFORE: { kr: '교육 전', en: 'EDU_BEFORE', class: '' },
	CANCEL: { kr: '취소', en: 'CANCEL', class: '' },
	undefined: { kr: '', en: '', class: '' }
}